import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Mail, Phone, Calendar, Building } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminInquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchInquiries = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_URL}/api/sponsor-inquiries`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInquiries(response.data);
    } catch (error) {
      toast.error('Failed to fetch inquiries');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this inquiry?')) return;
    
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`${API_URL}/api/sponsor-inquiries/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Inquiry deleted');
      fetchInquiries();
    } catch (error) {
      toast.error('Failed to delete inquiry');
    }
  };

  return (
    <div data-testid="admin-inquiries">
      <h1 className="font-['Oswald'] text-3xl text-[#F2EDE6] mb-8">SPONSOR INQUIRIES</h1>

      {loading ? (
        <p className="text-[#A19D98]">Loading...</p>
      ) : inquiries.length === 0 ? (
        <p className="text-[#A19D98]">No inquiries yet.</p>
      ) : (
        <div className="grid gap-4">
          {inquiries.map((inquiry) => (
            <div
              key={inquiry.id}
              data-testid={`inquiry-card-${inquiry.id}`}
              className="bg-[#141414] border border-[#2A2A2A] p-6"
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="font-['Oswald'] text-xl text-[#F2EDE6]">{inquiry.full_name}</h3>
                  <p className="text-[#E8651A] text-sm flex items-center gap-1">
                    <Building size={14} />
                    {inquiry.company_name}
                  </p>
                </div>
                <button
                  onClick={() => handleDelete(inquiry.id)}
                  className="p-2 text-[#A19D98] hover:text-[#FF3B30]"
                >
                  <Trash2 size={18} />
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm mb-4">
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Mail size={14} />
                  <a href={`mailto:${inquiry.email}`} className="hover:text-[#E8651A]">
                    {inquiry.email}
                  </a>
                </div>
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Phone size={14} />
                  <a href={`tel:${inquiry.phone}`} className="hover:text-[#E8651A]">
                    {inquiry.phone}
                  </a>
                </div>
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Calendar size={14} />
                  <span>{new Date(inquiry.created_at).toLocaleDateString()}</span>
                </div>
              </div>

              {inquiry.instagram_handle && (
                <p className="text-[#A19D98] text-sm mb-4">
                  Instagram: {inquiry.instagram_handle}
                </p>
              )}

              <div className="pt-4 border-t border-[#2A2A2A]">
                <p className="text-[#F2EDE6] text-sm whitespace-pre-wrap">{inquiry.message}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminInquiries;
